import { format } from "date-fns";

export const formatDate = (createdAt: string) => {
  try { 
    if (createdAt) {
      return format(new Date(createdAt), "dd.MM.yyyy");
    }
    return null;
  } catch (error) {
    console.error(error);
    return null;
  }
};
